import baseApi from '@/helpers/baseApi';
import { IErrorReport, ISystemMessage } from '@/helpers/interfaces/common.interface';

const apiUrl = process.env.API_URL;

const commonApi = {
  sendErrorReport: (data: IErrorReport) => baseApi.post<{ success: boolean }, IErrorReport>(`${apiUrl}/support/error`, data),

  getError: () => baseApi.get<{ error: string }>(`${apiUrl}/yclients/record/asd/asd`),
  makeError: () => baseApi.post<{ error: string }, {}>(`${apiUrl}/apikey/check`, { apikey: {} }),

  getSystemMessage: () => baseApi.get<ISystemMessage>(`${apiUrl}/systemmessages/active`).catch(() => { }),
};

export default commonApi;
